import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Button } from './button.js';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, } from './dialog.js';
/**
 * A confirmation dialog.
 *
 * Initial focus goes to **Cancel**, not to the confirm button. A dialog that
 * opens with the destructive action focused turns the Enter key someone was
 * already pressing into the confirmation, which is the exact input sequence a
 * confirmation exists to interrupt.
 */
export function ConfirmDialog({ open, onOpenChange, title, description, confirmLabel = 'Confirm', cancelLabel = 'Cancel', destructive = false, loading = false, onConfirm, }) {
    const cancelRef = useRef(null);
    return (_jsx(Dialog, { open: open, onOpenChange: onOpenChange, children: _jsxs(DialogContent, { onOpenAutoFocus: (event) => {
                event.preventDefault();
                cancelRef.current?.focus();
            }, children: [_jsxs(DialogHeader, { children: [_jsx(DialogTitle, { children: title }), _jsx(DialogDescription, { children: description })] }), _jsxs(DialogFooter, { children: [_jsx(Button, { ref: cancelRef, variant: "outline", disabled: loading, onClick: () => {
                                onOpenChange(false);
                            }, children: cancelLabel }), _jsx(Button, { variant: destructive ? 'destructive' : 'primary', loading: loading, onClick: onConfirm, children: confirmLabel })] })] }) }));
}
//# sourceMappingURL=confirm-dialog.js.map